import { render } from "./ResourceYaml.vue?vue&type=template&id=54d0e17a&scoped=true"
import script from "./ResourceYaml.vue?vue&type=script&lang=js"
export * from "./ResourceYaml.vue?vue&type=script&lang=js"

import "./ResourceYaml.vue?vue&type=style&index=0&id=54d0e17a&lang=scss&scoped=true"
import "./ResourceYaml.vue?vue&type=style&index=1&id=54d0e17a&lang=scss"

import exportComponent from "../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d0e17a"]])

export default __exports__